(function () {
  'use strict';

  angular.module('ringbaPortal').component('scheduleBreaks', {
    bindings: {
      breaks: '<',
      isMeridian: '<',
      onDelete: '&',
    },

    controller: ScheduleBreaksController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/concurrency-schedule/schedule-breaks/schedule-breaks.view.html'
  });

  function ScheduleBreaksController(
    utils
  ) {
    'ngInject';

    const vm = this;

    vm.$onChanges = onChanges;
    vm.getTimeDisplay = getTimeDisplay;
    vm.removeBreak = removeBreak;

    vm.hstep = 1;
    vm.mstep = 1;
    vm.isMeridian = true;
    vm.showAdvancedHours = false;
    vm.normalizedBreaks = _sortTimeInBreaks(vm.breaks);

    function onChanges(changeObj) {
      if (changeObj.breaks) {
        vm.normalizedBreaks = _sortTimeInBreaks(vm.breaks);
      }
    }

    function _sortTimeInBreaks(breaks) {
      if (!breaks) {
        return [];
      }

      return breaks.sort(function (timeA, timeB) {
        if (timeA.startTime.hour - timeB.startTime.hour === 0) {
          return timeA.startTime.minute - timeB.startTime.minute;
        }

        return timeA.startTime.hour - timeB.startTime.hour;
      });
    }

    function removeBreak(index) {
      vm.onDelete({
        $event: {
          breakToRemoveIndex: index
        }
      });
    }

    // TODO: Convert this to a filter
    function getTimeDisplay(time) {
      return utils.getTimeDisplay(time, vm.isMeridian);
    }
  }


})();
